import AiAnalytics from "./AiAnalytics";

export default AiAnalytics;